import Component from '../abstracts/Component';

export default class ShowPasswordComponent extends Component {

  get SELECTORS() {
    return {
      toggle: '.toggle-password',
    };
  }

  get CLASSES() {
    return {
      passwordVisible: 'icon-visibility-on',
      passwordNotVisible: 'icon-visibility-off'
    };
  }

  get COMPONENTNAME() {
    return 'ShowPasswordComponent';
  }

  constructor(htmlEl) {
    super(htmlEl);
    this.toggle = this.$component.querySelector(this.SELECTORS.toggle);
  }

  bindEvents() {
    this.toggle.addEventListener('click', (e) => {
      e.preventDefault();
      const input = e.currentTarget.parentElement.querySelector('input');
      const inputType = input.getAttribute('type');

      if (!input.value) return;

      switch (inputType) {
        case 'password':
          input.setAttribute('type', 'text');
          event.currentTarget.classList.add(this.CLASSES.passwordVisible);
          event.currentTarget.classList.remove(this.CLASSES.passwordNotVisible);
          break;
        case 'text':
          input.setAttribute('type', 'password');
          event.currentTarget.classList.add(this.CLASSES.passwordNotVisible);
          event.currentTarget.classList.remove(this.CLASSES.passwordVisible);
          break;
      }
    });
  }

  render() {
    this.log("Rendering...")
    this.bindEvents();
  }
}
